const T=e=>{const{assetId:s,format:_,dimensions:n}=e;return`${process.env.NEXT_PUBLIC_ASSET_BASE_URL}images/${process.env.NEXT_PUBLIC_SANITY_PROJECT_ID}/${process.env.NEXT_PUBLIC_SANITY_DATASET}/${s}-${n}.${_}`};export{T as getImgURL};
